const evaluationsNamespace = '/evaluations';

const evaluationListViewRelative = '/';

const evaluationListViewRoute = `${evaluationsNamespace}`;

export const evaluationsNamespaces = {
    evaluationsNamespace,
};

export const evaluationsRelativeRoutes = {
    evaluationListViewRelative,
};

export const evaluationsAbsoluteRoutes = {
    evaluationListViewRoute,
};
